import React from 'react';
import { Send, TrendingUp, CheckCircle, MapPin } from 'lucide-react';

const STEPS = [
  { icon: Send, title: 'Submit Request', desc: 'Share pickup and delivery details', gradient: 'from-amber-500 to-orange-500', borderColor: 'border-amber-500', textColor: 'text-amber-500', shadow: 'shadow-amber-500/30', num: 1 },
  { icon: TrendingUp, title: 'Get Quote', desc: 'Receive instant competitive pricing', gradient: 'from-orange-500 to-red-500', borderColor: 'border-orange-500', textColor: 'text-orange-500', shadow: 'shadow-orange-500/30', num: 2 },
  { icon: CheckCircle, title: 'Approve & Pay', desc: 'Confirm booking and make payment', gradient: 'from-red-500 to-pink-500', borderColor: 'border-red-500', textColor: 'text-red-500', shadow: 'shadow-red-500/30', num: 3 },
  { icon: MapPin, title: 'Track & Receive', desc: 'Real-time tracking until delivery', gradient: 'from-pink-500 to-purple-500', borderColor: 'border-purple-500', textColor: 'text-purple-500', shadow: 'shadow-pink-500/30', num: 4 }
];

export const ProcessSection = () => (
  <section id="how-it-works" className="py-32 bg-slate-50 dark:bg-[#050505]">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center mb-20">
        <span className="inline-block px-4 py-2 bg-amber-500/10 text-amber-600 dark:text-amber-500 rounded-full text-sm font-bold mb-4">SIMPLE PROCESS</span>
        <h2 className="font-outfit text-5xl font-black text-slate-900 dark:text-white mb-6">How It Works</h2>
        <p className="text-xl text-slate-600 dark:text-slate-400 max-w-2xl mx-auto">Four simple steps from request to delivery</p>
      </div>
      <div className="grid md:grid-cols-4 gap-8 relative">
        <div className="hidden md:block absolute top-16 left-[12.5%] right-[12.5%] h-1 bg-gradient-to-r from-amber-500 via-orange-500 to-red-500 opacity-20"></div>
        {STEPS.map(step => (
          <div key={step.num} className="relative text-center group">
            <div className={`w-32 h-32 mx-auto bg-gradient-to-br ${step.gradient} rounded-3xl flex items-center justify-center mb-6 group-hover:scale-110 transition-all duration-300 shadow-2xl ${step.shadow}`}>
              <step.icon className="w-16 h-16 text-white" />
            </div>
            <div className={`absolute top-2 right-1/2 translate-x-1/2 w-12 h-12 bg-white dark:bg-slate-900 border-4 ${step.borderColor} rounded-full flex items-center justify-center font-outfit font-black text-2xl ${step.textColor}`}>
              {step.num}
            </div>
            <h3 className="font-outfit text-xl font-bold text-slate-900 dark:text-white mb-3">{step.title}</h3>
            <p className="text-slate-600 dark:text-slate-400">{step.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
